import { useCallback } from "react";
import { usePostApi } from "src/hooks/usePostApi";
import { useDispatch } from "src/redux/hooks";
import { isOnline } from "src/utils/isOnline";
import { flushStoredChecklistQueue } from "./flushChecklistQueue";

/**
 * Offline the autosave never fires, so only a manual save drained the outbox
 * and a tick could sit there indefinitely. An entry that already has an id has
 * nothing to wait for: the action can be queued for upload straight away.
 *
 * An entry with no id yet is not queued - there is nothing to attach the
 * action to until the first save mints one - so it stays in the outbox.
 */
export const useOfflineChecklistFlush = () => {
  const dispatch = useDispatch();
  const { post } = usePostApi();

  return useCallback(
    (entryId: string) => {
      if (!entryId || entryId === "new" || isOnline()) return;

      // Read from the store rather than a selector: the actions being flushed
      // were dispatched in this same tick.
      void flushStoredChecklistQueue(post, entryId, dispatch);
    },
    [dispatch, post],
  );
};
